import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";

export const getAllQuestions = async (params = {}) => {
  const url = `${API_ENDPOINT.QUESTION_TAB.GET_ALL_QUESTIONS}`;
  try {
    const response = await axios.post(url, params);
    return response.data;
  } catch (error) {
    console.error("Get All Questions API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const updateQuestion = async (id, payload) => {
  const url = `${API_ENDPOINT.QUESTION_TAB.UPDATE_QUESTION}/${id}`;
  try {
    const response = await axios.put(url, payload);
    return response.data;
  } catch (error) {
    console.error("Update Question API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};